/**
 * Nav columns drawer menu — loaded separately because the storefront uses theme.dev.js
 * which does not include this logic.
 */
(function () {
  function initNavColumns() {
    const mobileQuery = window.matchMedia('(max-width: 767px)');

    document.querySelectorAll('[data-nav-columns]').forEach((root) => {
      if (root.dataset.navColumnsBound === 'true') return;
      root.dataset.navColumnsBound = 'true';

      const panel = root.querySelector('[data-nav-columns-panel]');
      const col3 = root.querySelector('[data-nav-col="3"]');
      const media = root.querySelector('[data-nav-columns-media]');
      const menusContainer = root.querySelector('[data-nav-columns-menus]');
      if (!panel || !col3) return;

      const isMobile = () => mobileQuery.matches;

      const resetPanelSources = () => {
        root.querySelectorAll('.nav-columns__panel-source').forEach((el) => {
          el.setAttribute('aria-hidden', 'true');
        });
      };

      const closeAccordions = () => {
        root.querySelectorAll('.nav-columns__accordion').forEach((el) => el.remove());
      };

      const restoreDefaultPanel = () => {
        panel.innerHTML = '';
        col3.hidden = true;
        col3.scrollTop = 0;

        root.querySelectorAll('[data-nav-columns-open]').forEach((btn) => {
          btn.setAttribute('aria-expanded', 'false');
        });
        resetPanelSources();
      };

      const closeAll = () => {
        closeAccordions();
        restoreDefaultPanel();
      };

      const noMediaSections = ['accessories'];
      const sectionAliases = { 'gift-sets': 'perfume-sets' };

      const setActiveSection = (sectionHandle) => {
        if (!media || !sectionHandle) return;

        let normalized = sectionHandle.toLowerCase().trim();
        normalized = sectionAliases[normalized] || normalized;
        let found = false;

        media.querySelectorAll('[data-nav-section-image]').forEach((item) => {
          const itemSection = (item.getAttribute('data-nav-section-image') || '').toLowerCase().trim();
          const isMatch = itemSection === normalized;
          item.classList.toggle('is-active', isMatch);
          if (isMatch) found = true;
        });

        if (!found && !noMediaSections.includes(normalized)) {
          const defaultSection = root.dataset.navDefaultSection;
          if (defaultSection && defaultSection.toLowerCase().trim() !== normalized) {
            setActiveSection(defaultSection);
          }
        }
      };

      const getPanelNode = (button) => {
        const panelSource = button.parentElement?.querySelector('[data-nav-columns-panel-source]');
        const panelInner = panelSource?.querySelector('.nav-columns__panel');
        return panelInner ? panelInner.cloneNode(true) : null;
      };

      const setButtonOpen = (button, open) => {
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        const panelSource = button.nextElementSibling;
        if (panelSource?.matches('.nav-columns__panel-source')) {
          panelSource.setAttribute('aria-hidden', open ? 'false' : 'true');
        }
      };

      const openCol3 = (button, panelNode) => {
        closeAccordions();
        panel.innerHTML = '';
        panel.appendChild(panelNode);
        col3.hidden = false;
        col3.scrollTop = 0;

        root.querySelectorAll('[data-nav-columns-open]').forEach((btn) => {
          btn.setAttribute('aria-expanded', btn === button ? 'true' : 'false');
        });
        resetPanelSources();
      };

      let leaveTimer = null;
      const settle = (fn, delay) => {
        clearTimeout(leaveTimer);
        leaveTimer = setTimeout(fn, delay);
      };

      // True hover-intent: only fires once the pointer has actually settled
      // (stopped moving) over the element, so a fast diagonal pass-through
      // on the way to the panel/images never hijacks the open category.
      let pointerX = 0;
      let pointerY = 0;
      root.addEventListener('mousemove', (event) => {
        pointerX = event.clientX;
        pointerY = event.clientY;
      });

      const hoverIntent = (el, callback, delay = 100, sensitivity = 10) => {
        let pollTimer = null;
        let lastX = 0;
        let lastY = 0;

        const poll = () => {
          const dist = Math.hypot(pointerX - lastX, pointerY - lastY);
          if (dist < sensitivity) {
            callback();
            return;
          }
          lastX = pointerX;
          lastY = pointerY;
          pollTimer = setTimeout(poll, delay);
        };

        el.addEventListener('mouseenter', () => {
          lastX = pointerX;
          lastY = pointerY;
          clearTimeout(pollTimer);
          pollTimer = setTimeout(poll, delay);
        });
        el.addEventListener('mouseleave', () => clearTimeout(pollTimer));
      };

      const activatePanel = (button) => {
        const sectionHandle = button.getAttribute('data-menu-section');
        if (sectionHandle) setActiveSection(sectionHandle);

        if (isMobile()) {
          const isOpen = button.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            closeAll();
            return;
          }
          closeAll();
          setButtonOpen(button, true);
          return;
        }

        const panelNode = getPanelNode(button);
        if (panelNode) {
          openCol3(button, panelNode);
        }
      };

      root.querySelectorAll('[data-nav-columns-open]').forEach((button) => {
        hoverIntent(button, () => {
          if (!isMobile()) activatePanel(button);
        });
        button.addEventListener('focus', () => {
          if (!isMobile()) activatePanel(button);
        });
        button.addEventListener('click', (event) => {
          if (!isMobile()) return;

          // On mobile, a category with children (Perfumes, Home Fragrances,
          // Body & Hair Care, Perfume Sets) needs to do two different things
          // depending on exactly where the tap lands: tapping the +/chevron
          // icon expands the accordion in place (Fresh/Fruity/Floral/Woody
          // etc. stay reachable without leaving the menu), while tapping the
          // text itself should navigate straight to the collection page —
          // the same "does this category page have real content to land on"
          // question a first-time visitor is actually asking. Only the icon
          // tap is intercepted; a text tap falls through to the native
          // <a href> untouched.
          if (!event.target.closest('.nav-columns__item-suffix')) return;

          event.preventDefault();
          event.stopPropagation();
          activatePanel(button);
        });
      });

      root.querySelectorAll('[data-menu-section]').forEach((el) => {
        if (el.matches('[data-nav-columns-open]')) return;

        const activateSection = () => {
          const sectionHandle = el.getAttribute('data-menu-section');
          if (sectionHandle) setActiveSection(sectionHandle);
          if (!isMobile()) {
            closeAccordions();
            restoreDefaultPanel();
          }
        };

        hoverIntent(el, () => {
          if (!isMobile()) activateSection();
        });
        el.addEventListener('focus', activateSection);
      });

      // The theme's own scroll-lock (enabled while the drawer is open)
      // only exempts the single element it was told about when the drawer
      // opened, not this nested scroll region — so native touch-scrolling
      // inside the menu list gets swallowed everywhere on real iOS Safari.
      // Driving scrollTop by hand from raw touch coordinates sidesteps
      // that entirely: it's a plain DOM write, not a scroll gesture, so no
      // preventDefault() anywhere else can block it.
      //
      // Release velocity is measured over the last ~60ms of movement
      // (not the single last touchmove) so one noisy/short event interval
      // can't produce a wildly wrong reading, and it's clamped to a sane
      // range before the friction-based momentum decay runs — keeping the
      // coast-after-release feel close to native inertial scrolling
      // instead of stopping dead the instant the finger lifts.
      if (menusContainer) {
        let touchStartY = 0;
        let touchStartScrollTop = 0;
        let samples = [];
        let velocity = 0;
        let momentumFrame = null;

        const stopMomentum = () => {
          if (momentumFrame) cancelAnimationFrame(momentumFrame);
          momentumFrame = null;
        };

        const runMomentum = () => {
          velocity *= 0.94;
          menusContainer.scrollTop += velocity;
          if (Math.abs(velocity) > 0.05) {
            momentumFrame = requestAnimationFrame(runMomentum);
          } else {
            momentumFrame = null;
          }
        };

        menusContainer.addEventListener(
          'touchstart',
          (event) => {
            if (!isMobile() || !event.touches.length) return;
            stopMomentum();
            touchStartY = event.touches[0].clientY;
            touchStartScrollTop = menusContainer.scrollTop;
            samples = [{ t: event.timeStamp, y: touchStartY }];
            velocity = 0;
          },
          { passive: true }
        );

        menusContainer.addEventListener(
          'touchmove',
          (event) => {
            if (!isMobile() || !event.touches.length) return;
            const currentY = event.touches[0].clientY;
            menusContainer.scrollTop = touchStartScrollTop + (touchStartY - currentY);

            samples.push({ t: event.timeStamp, y: currentY });
            const cutoff = event.timeStamp - 60;
            while (samples.length > 2 && samples[0].t < cutoff) samples.shift();
          },
          { passive: true }
        );

        menusContainer.addEventListener(
          'touchend',
          () => {
            if (!isMobile()) return;

            if (samples.length >= 2) {
              const first = samples[0];
              const last = samples[samples.length - 1];
              const dt = last.t - first.t;
              if (dt > 0) {
                velocity = ((first.y - last.y) / dt) * 16.6667;
                velocity = Math.max(-120, Math.min(120, velocity));
              }
            }

            if (Math.abs(velocity) > 0.5) {
              momentumFrame = requestAnimationFrame(runMomentum);
            }
          },
          { passive: true }
        );
      }

      if (menusContainer) {
        menusContainer.addEventListener('mouseleave', () => {
          if (isMobile()) return;
          settle(() => {
            restoreDefaultPanel();
            const defaultSection = root.dataset.navDefaultSection;
            if (defaultSection) setActiveSection(defaultSection);
          }, 160);
        });
      }

      const drawer = root.closest('[data-drawer="hamburger"]');
      if (drawer) {
        const resetNavColumns = () => {
          closeAll();
          const defaultSection = root.dataset.navDefaultSection;
          if (defaultSection) setActiveSection(defaultSection);
        };

        drawer.addEventListener('theme:drawer:close', resetNavColumns);
        drawer.addEventListener('theme:drawer:open', () => {
          closeAll();
          const defaultSection = root.dataset.navDefaultSection;
          if (defaultSection) setActiveSection(defaultSection);
        });
      }

      mobileQuery.addEventListener('change', closeAll);
      restoreDefaultPanel();

      const defaultSection = root.dataset.navDefaultSection;
      if (defaultSection) setActiveSection(defaultSection);
    });
  }

  document.addEventListener('DOMContentLoaded', initNavColumns);
  document.addEventListener('shopify:section:load', initNavColumns);
})();
